import fontsCom from './providers/fonts.com';

const fontProviders = {
	'fonts.com': fontsCom,
};

function getProvider(provider, ...restArguments) {
	if (provider in fontProviders) {
		fontProviders[provider](...restArguments);
	} else {
		console.warn(`sky-fonts did not find "${provider}" in implemented font providers.`);
	}
}

export default getProvider;



// WEBPACK FOOTER //
// ./scripts/sky-fonts/index.js